import React         from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import _             from 'lodash';

const textTransformation = (s) => {
  let text = _.replace(s, /<c>/g, '<span class="badge badge-pill badge-info">');
  text = _.replace(text, /<r>/g, '<span class="badge badge-pill badge-danger">');
  text = _.replace(text, /<\/c>|<\/r>/g, '</span>');
  return text;
};

const DebugItem = (props) => {
  const { debug } = props;
  const lines = [];
  if (debug.description) {
    debug.description
      .forEach((line, number) => {
        lines.push(textTransformation(line.text));
      });
  }
  return (
    <tr>
      <td style={{
        width           : '1%',
        'whiteSpace'   : 'nowrap',
        'verticalAlign': 'top',
        'textAlign'    : 'right',
      }}>
        {debug.name.text}
      </td>
      <td className="ps-1" dangerouslySetInnerHTML={{ __html: _.join(lines, '<br />') }} />
    </tr>
  );
};

const PriceMatrixDebug = (props) => {
  const { lineItem } = props;
  if (!lineItem || !lineItem.debug || !lineItem.debug.charge_calculation) {
    return null;
  }

  const chargeCalculation = lineItem.debug.charge_calculation;
  // const quantities = chargeCalculation.keySeq();
  const quantities = Object.keys(chargeCalculation);

  const [key, setKey] = React.useState(_.head(quantities));

  if (!quantities.includes(key)) {
    setKey(_.head(quantities));
  }

  return (
    <div className="debug-section mt-3">
      <Tabs activeKey={key} onSelect={k => setKey(k)} id="controlled-tab-example">
        {quantities.map(qty => (
          <Tab key={qty} eventKey={qty} title={`Quantity ${qty}`}>
            <div className="card card-body">
              <table>
                <tbody>

                  {chargeCalculation[qty]
                    .map((item, number) => (
                      <DebugItem key={number} debug={item} />
                    ))}

                </tbody>
              </table>
            </div>

          </Tab>
        ))}
      </Tabs>
    </div>
  );
};

export default PriceMatrixDebug;
